module.exports = __webpack_public_path__ + "img/Icon_Finalizacion_de_Periodo.728b7891.svg";